import { qs } from '@fluorescent/dom';
import Delegate from 'ftdomdelegate';

import { emit } from '@/glow/events';

const selectors = {
  variantPopupTrigger: '[data-variant-popup-trigger]',
};

const variantPopup = node => {
  const delegate = new Delegate(node);

  const _variantPopupHandler = e => {
    e.preventDefault();

    const { modalContentId } = e.target.dataset;
    const moreInfoContent = qs(`#${modalContentId}`, node);

    emit('modal:open', null, {
      modalContent: moreInfoContent,
    });
  };

  delegate.on('click', selectors.variantPopupTrigger, _variantPopupHandler);

  const unload = () => {
    delegate.destroy();
  };

  return { unload };
};

export default variantPopup;
